import { useLanguage } from '@/i18n/LanguageContext';

const badgeKeys = [
  { nameKey: 'firstExpression' as const, pts: 10 },
  { nameKey: 'relationshipCelebrant' as const, pts: 15 },
  { nameKey: 'birthdayChampion' as const, pts: 15 },
  { nameKey: 'friendshipKeeper' as const, pts: 15 },
  { nameKey: 'consistencyStar' as const, pts: 20 },
  { nameKey: 'loveAmbassador' as const, pts: 25 },
];

const levelKeys = [
  { nameKey: 'heartOpener' as const, pts: 0, emoji: '💚' },
  { nameKey: 'soulConnector' as const, pts: 50, emoji: '💙' },
  { nameKey: 'loveAmbassador' as const, pts: 100, emoji: '💜' },
  { nameKey: 'gratitudeChampion' as const, pts: 175, emoji: '💛' },
  { nameKey: 'legacyMaker' as const, pts: 250, emoji: '❤️' },
];

export function BadgeFAQContent() {
  const { t } = useLanguage();
  const f = t.faq?.badgesFaq;

  if (!f) return null;

  return (
    <div className="space-y-6 text-muted-foreground leading-relaxed">
      <p>{f.intro}</p>

      {/* How badges are earned */}
      <div>
        <h4 className="font-semibold text-foreground mb-3">{f.howEarnedTitle}</h4>
        <p className="mb-4 text-sm">{f.howEarnedSubtitle}</p>
        <div className="space-y-4">
          {badgeKeys.map((badge) => {
            const b = f.badges[badge.nameKey];
            if (!b) return null;
            return (
              <div key={badge.nameKey} className="pl-4 border-l-2 border-primary/30">
                <p className="font-semibold text-foreground">
                  {b.name} <span className="text-sm font-normal text-muted-foreground">({badge.pts} pts)</span>
                </p>
                <p className="text-sm">{b.earned}</p>
                {b.trigger && <p className="text-sm text-muted-foreground/80 italic">{b.trigger}</p>}
                {'note' in b && b.note && (
                  <p className="text-sm text-primary/80 mt-1 font-medium">{b.note}</p>
                )}
              </div>
            );
          })}
        </div>
      </div>

      {/* Level progression */}
      <div>
        <h4 className="font-semibold text-foreground mb-3">{f.levelsTitle}</h4>
        <p className="mb-3 text-sm">{f.levelsSubtitle}</p>
        <div className="grid gap-2">
          {levelKeys.map((level) => (
            <div key={level.nameKey} className="flex items-center gap-2 text-sm">
              <span>{level.emoji}</span>
              <span className="font-medium text-foreground">{f.levels[level.nameKey]}</span>
              <span className="text-muted-foreground">— {level.pts} {f.pointsLabel}</span>
            </div>
          ))}
        </div>
        <p className="mt-3 text-sm">{f.levelsNote}</p>
      </div>

      {/* Date note */}
      <div className="bg-muted/50 rounded-lg p-4">
        <h4 className="font-semibold text-foreground mb-1">{f.dateNoteTitle}</h4>
        <p className="text-sm">{f.dateNoteBody}</p>
      </div>

      {/* Final note */}
      <p className="italic text-sm">{f.finalNote}</p>
    </div>
  );
}
